import React from "react";
//#region types
import { FormFieldWrapperProps } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
//#endregion
//#region components
import FormFieldContainerMemoized from "./formFieldContainerMemoized";
import FormFieldContainerNonMemoized from "./formFieldContainerNonMemoized";
import { Field, FieldProps, getIn } from "formik";
//#endregion

function FormFieldWrapper<T extends Record<string, any>>(props: FormFieldWrapperProps<T>) {
  const { name } = props;

  return (
    <Field name={name}>
      {(fieldProps: FieldProps) => {
        const { error, value } = fieldProps.meta;
        const { touched } = fieldProps.form;

        let fieldTouched = getIn(touched, name);

        const fieldNameSections = name.split(".");

        if (fieldTouched === undefined && (fieldNameSections?.length ?? 0 > 1)) {
          let currentSection;
          for (let i = 0; i < fieldNameSections.length; i++) {
            currentSection = currentSection ? `${currentSection}.${fieldNameSections[i]}` : fieldNameSections[i];
            if (getIn(touched, currentSection) === true) {
              fieldTouched = true;
              break;
            }
          }
        }

        //check error length to fix issue with array items picking up array base error's characters
        const fieldError = typeof error === "string" && error.length === 1 ? undefined : error;

        //To avoid delayed effects when using memoized component with textarea
        const isMemoized = props.field.type !== FormEnums.FormFieldType.TEXTAREA;
        const FormFieldContainer = isMemoized ? FormFieldContainerMemoized : FormFieldContainerNonMemoized;

        return (
          <FormFieldContainer<T>
            key={props.name}
            fieldRef={props.fieldRef}
            name={props.name}
            field={props.field}
            hideErrorBubble={props.hideErrorBubble}
            hideSuccess={props.hideSuccess}
            messagePlacement={props.messagePlacement}
            invertedDisplayType={props.invertedDisplayType}
            inline={props.inline}
            enableControlLables={props.enableControlLables}
            contentWidth={props.contentWidth}
            formGridLayout={props.formGridLayout}
            layout={props.layout}
            validationSchema={props.validationSchema}
            overrideOptional={props.overrideOptional}
            hideOptionalIndicator={props.hideOptionalIndicator}
            focusField={props.focusField}
            value={value}
            errors={fieldError}
            touched={fieldTouched}
            disabled={props.disabled}
          />
        );
      }}
    </Field>
  );
}

export default FormFieldWrapper;
